'use strict'

export default class ShowController {

  /*@ngInject*/
  constructor ($http, $stateParams) {
    this.$http = $http
    this.$stateParams = $stateParams
  }

  $onInit () {
    this.getConf(this.$stateParams.id)
  }

  getConf (id) {
    this.$http.get('/api/deviceconfigs/' + id).then(response => {
      this.conf = response.data
    })
  }

}



// WEBPACK FOOTER //
// ./client/app/deviceconfigs/show/show.controller.js